
/* SELVANE Lazy Section Loader v1.0
 * Defers rendering of below-fold sections until they approach the viewport
 * Uses IntersectionObserver for efficient scroll detection
 */
(function() {
  'use strict';
  
  // Skip if IntersectionObserver not supported
  if (!('IntersectionObserver' in window)) return;
  
  // Target sections with data-selvane-lazy attribute
  var lazySections = document.querySelectorAll('[data-selvane-lazy]');
  if (!lazySections.length) return;
  
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var section = entry.target;
        // Remove the placeholder and show real content
        section.style.contentVisibility = 'visible';
        section.style.containIntrinsicSize = 'none';
        observer.unobserve(section);
      }
    });
  }, {
    rootMargin: '200px 0px', // Start loading 200px before visible
    threshold: 0
  });
  
  lazySections.forEach(function(section) {
    observer.observe(section);
  });
})();
